import { getTcccLoginToken } from "@/api/Tccc/index";
import { ElMessage } from 'element-plus'
import { getToken } from '@/utils/auth'


export const initTccc = async (isLogin=false,showErr=true)=>{
    if(!getToken()){
        return false
    }
    const { data } = await getTcccLoginToken();
    if(data){
        if(data.outboundDialerProvider == 'tencent'){
            const { Response } = data;
            if(Response){
                const res = await injectTcccWebSDK(Response);
                return data
            }
        }else if(data.outboundDialerProvider == 'ali'){
            if(isLogin){
                CTILinkSetup(data)
            }
            return data
        }
    }else{
        if(showErr){
            ElMessage({
                message: 'Tccc-sdk初始化失败,无法外呼',
                type: 'error',
            })
        }
        return false
    }
}
//腾讯外呼初始化
export const initTXTccc = async () => {
    if(!getToken()){
        return false
    }
    const { data } = await getTcccLoginToken();
    if(data){
        const { Response } = data;
        if(Response){
            const res = await injectTcccWebSDK(Response);
            return data
        }
    }else{
        ElMessage({
            message: 'Tccc-sdk初始化失败,无法外呼',
            type: 'error',
        })
    }
    return false
};

//外呼初始化
export function injectTcccWebSDK(response) {
    // if (window.tccc) {
    //     console.warn("已经初始化SDK了，请确认是否重复执行初始化");
    //     return;
    // }
    return new Promise((resolve, reject) => {
        const script = document.createElement("script");
        script.setAttribute("crossorigin", "anonymous");
        // script.dataset.token = response.token
        // script.dataset.ExpiredTime = response.ExpiredTime
        script.dataset.RequestId = response.RequestId
        // 需要渲染进的DomId，如果填写则没有悬浮窗，工作台直接渲染进指定的 dom 元素
        // 为保证工作台 UI 完整，渲染的 Dom 最小高度为480px，最小宽度为760px
        // script.dataset.renderDomId = "renderDom";
        script.src = response.SdkURL;
        document.body.appendChild(script);
        script.addEventListener("load", () => {
            // 加载JS SDK文件成功，此时可使用全局变量"tccc"
            window.tccc.UI.hidefloatButton();
            window.tccc.UI.hideWorkbench()
            window.tccc.on(window.tccc.events.ready, () => {
                /**
                 * Tccc SDK 初始化成功，此时可调用外呼、监听呼入事件等功能。
                 * 注意⚠️：请确保只初始化一次 SDK
                 * */
                console.log("初始化成功");
                resolve(true);
            });
            window.tccc.on(window.tccc.events.tokenExpired, ({ message }) => {
                console.error("初始化失败", message);
                reject(false);
            });
        });
    });
}

//阿里初始化
export function CTILinkSetup(data){
    console.log(data)
    CTILink.setup({webrtc: true},function(){
        const params = {
            sessionKey:data.sessionKey,
            enterpriseId:data.enterpriseId,
            bindTel:data.extensionNumber,
            bindType:3,
            cno:data.cno,
            loginStatus:1,
            webSocketUrl:data.agentGateWayUrl,
            // qids:data.qids
        }
        console.log(params)
        CTILink.Agent.login(params, function(result) {
            console.log(result)
            if (result.code == 0) {
                //座席登录成功
                console.log('座席登录成功');
            } else {
                ElMessage({
                    message: result.msg,
                    type: 'error',
                })
                //座席登录失败，失败原因： + result.msg
            }
        });
    })
}
